import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createUnhead, headSymbol } from '@unhead/vue'
import * as Sentry from '@sentry/vue'
import VueEasyLightbox from 'vue-easy-lightbox'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faAngleRight,
  faCalendar,
  faPlane,
  faTrain,
  faCar,
} from '@fortawesome/free-solid-svg-icons'

import App from './App.vue'
import router from './router'
import i18n from './i18n'

library.add(faAngleRight, faCalendar, faPlane, faTrain, faCar)

const app = createApp(App)
const head = createUnhead({ document })

Sentry.init({
  app,
  dsn: 'https://c763a8d46733d4e0029ed931b2cc5dfd@o4511015226245120.ingest.de.sentry.io/4511015228211280',
  integrations: [
    Sentry.browserTracingIntegration({ router }),
  ],
  tracesSampleRate: 0.2,
  sendDefaultPii: true,
  environment: import.meta.env.MODE,
  beforeSend(event, hint) {
    const error = hint.originalException
    if (error instanceof DOMException && error.name === 'AbortError') return null
    if (error instanceof Error && error.name === 'AbortError') return null
    return event
  },
})

app.use(createPinia())
app.use(router)
app.use(i18n)
app.provide(headSymbol, head)
app.use(VueEasyLightbox)
app.component('FontAwesomeIcon', FontAwesomeIcon)

app.mount('#app')
